import styles from './Header.css'

class Header extends React.Component {
  render () {
    return (<div className={styles['wrapper']}>{this.props.title}</div>)
  }
}

Header.propTypes = {
  title: React.PropTypes.string
}

export default Header



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Receipt/Header/Header.js